import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Order New Number'
      breadcrumbs={[
        {
          label: 'Phone',
        },
        {
          label: 'Order New Number',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/phone/order-new-number',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
